import React, { useState } from "react";
import { Box, Tab, Tabs, Typography, Paper, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import IncidentVideosTab from "../../Components/Common/IncidentVideosTab";
import NoEntryPolygonEditor from "../../Components/Common/NoEntryPolygonEditor";
import NoEntryIncidentsChart from "../../Components/NoEntry/NoEntryIncidentsChart";
import NoEntryConfidenceAudit from "../../Components/NoEntry/NoEntryConfidenceAudit";
import { baseURL } from "../../utils/StaticVariables";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`no-entry-tabpanel-${index}`}
      aria-labelledby={`no-entry-tab-${index}`}
      style={{ minHeight: "calc(100vh - 200px)" }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, animation: "fadeIn 0.5s ease-in-out" }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `no-entry-tab-${index}`,
    "aria-controls": `no-entry-tabpanel-${index}`,
  };
}

const NoEntryVisualizations = () => {
  const [selectedChart, setSelectedChart] = useState("incidents_per_camera");

  return (
    <Box sx={{ p: 1, display: "flex", flexDirection: "column", width: "100%" }}>
      <Box sx={{ maxWidth: 400, mb: 4 }}>
        <FormControl fullWidth>
          <InputLabel id="no-entry-vis-select-label">Select Visualization</InputLabel>
          <Select
            labelId="no-entry-vis-select-label"
            value={selectedChart}
            label="Select Visualization"
            onChange={(e) => setSelectedChart(e.target.value)}
          >
            <MenuItem value="incidents_per_camera">
              Number of Incidents per Camera
            </MenuItem>
            <MenuItem value="confidence_audit">
              Model Confidence Audit
            </MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ animation: "fadeIn 0.5s ease-in-out", width: "100%" }}>
        {selectedChart === "incidents_per_camera" ? (
          <NoEntryIncidentsChart />
        ) : (
          <NoEntryConfidenceAudit />
        )}
      </Box>
    </Box>
  );
};

const NoEntryMain = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: "bold" }}>
        No Entry Area Detection
      </Typography>

      <Paper elevation={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "background.paper" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="No Entry Area dashboard tabs"
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
            sx={{
              "& .MuiTab-root": {
                fontWeight: 600,
                fontSize: "1rem",
                textTransform: "none",
                py: 2.5,
              },
            }}
          >
            <Tab label="Incident Videos" {...a11yProps(0)} />
            <Tab label="Visualizations" {...a11yProps(1)} />
            <Tab label="Area of Interest" {...a11yProps(2)} />
          </Tabs>
        </Box>

        <Box sx={{ bgcolor: "background.default" }}>
          <CustomTabPanel value={value} index={0}>
            <IncidentVideosTab
              featureName="No-Entry Zone"
              featureKey="no-entry-zone"
              apiEndpoint={`${baseURL}no-entry-zone/events`}
              resolveEndpoint={`${baseURL}no-entry-zone/events/{event_id}/resolve`}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <NoEntryVisualizations />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <NoEntryPolygonEditor />
          </CustomTabPanel>
        </Box>
      </Paper>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </Box>
  );
};

export default NoEntryMain;
